export default __webpack_public_path__ + "static/media/image4.0d2367e8.png";